import { render, staticRenderFns } from "./ActiveDetailDialogPerview.vue?vue&type=template&id=2256fc32&scoped=true&"
import script from "./ActiveDetailDialogPerview.vue?vue&type=script&lang=js&"
export * from "./ActiveDetailDialogPerview.vue?vue&type=script&lang=js&"
import style0 from "./ActiveDetailDialogPerview.vue?vue&type=style&index=0&id=2256fc32&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2256fc32",
  null
  
)

export default component.exports